// Term Library - Glossary for contextual tooltips
// Leadership terms with "Pocket Definitions"

export const TERM_LIBRARY = {
  // PSEL Standards
  'PSEL': {
    term: 'PSEL',
    definition: 'A leadership standards framework used to define and evaluate school leadership practice.',
    category: 'standards',
  },
  'PSEL 2': {
    term: 'PSEL 2',
    definition: 'Ethics and Professional Norms - Leaders act ethically and professionally in personal conduct, relationships, and decisions.',
    category: 'standards',
  },
  'PSEL 3': {
    term: 'PSEL 3',
    definition: 'Equity and Cultural Responsiveness - Leaders strive for equity by recognizing each student\'s strengths and addressing biases.',
    category: 'standards',
  },
  'PSEL 7': {
    term: 'PSEL 7',
    definition: 'Professional Community for Teachers and Staff - Leaders foster professional capacity and practice through trust, collaboration, and growth.',
    category: 'standards',
  },
  
  // Leadership Concepts
  'psychological safety': {
    term: 'Psychological Safety',
    definition: 'A shared belief that the team is safe for interpersonal risk-taking—speaking up without fear of punishment or humiliation.',
    category: 'concept',
  },
  'inquiry-first': {
    term: 'Inquiry First',
    definition: 'A leadership stance that prioritizes understanding through questions before making judgments or delivering directives.',
    category: 'approach',
  },
  'escalation risk': {
    term: 'Escalation Risk',
    definition: 'The likelihood that a conversation will shift from collaborative problem-solving to adversarial conflict.',
    category: 'metric',
  },
  'trust': {
    term: 'Trust',
    definition: 'The willingness to stay open, honest, and engaged in a difficult conversation.',
    category: 'metric',
  },
  'efficacy': {
    term: 'Efficacy',
    definition: 'A teacher\'s sense that they can improve practice without being diminished.',
    category: 'metric',
  },
  'clarity': {
    term: 'Clarity',
    definition: 'Shared understanding between parties about the issue, expectations, and path forward.',
    category: 'metric',
  },
  
  // Conversation Moves
  'stabilize': {
    term: 'Stabilize',
    definition: 'A conversational move that reduces emotional intensity and creates safety before addressing difficult content.',
    category: 'move',
  },
  'seek': {
    term: 'Seek',
    definition: 'A conversational move focused on gathering information and understanding the other person\'s perspective.',
    category: 'move',
  },
  'name': {
    term: 'Name',
    definition: 'A conversational move that articulates the issue clearly without assigning blame or intent.',
    category: 'move',
  },
  'move': {
    term: 'Move',
    definition: 'The step that turns the conversation toward next actions or commitments.',
    category: 'move',
  },
  
  // Failure Patterns
  'reassurance trap': {
    term: 'The Reassurance Trap',
    definition: 'A pattern where leaders over-soften feedback, preserving comfort at the expense of clarity and growth.',
    category: 'pattern',
  },
  'compliance without buy-in': {
    term: 'Compliance Without Buy-In',
    definition: 'When a teacher follows directives without genuine ownership—often leading to minimal effort and resentment.',
    category: 'pattern',
  },
  
  // Equity
  'equity lens': {
    term: 'Equity Lens',
    definition: 'A deliberate practice of examining how bias, context, and systemic factors may influence a situation or decision.',
    category: 'concept',
  },
  'family history': {
    term: 'Family History',
    definition: 'Prior interactions and relationship dynamics between a family and the school that may shape current perceptions.',
    category: 'context',
  },
  
  // Emotional States
  'guarded': {
    term: 'Guarded',
    definition: 'A state where the person is watchful and cautious, not yet trusting the conversation\'s direction.',
    category: 'emotional_state',
  },
  'defensive': {
    term: 'Defensive',
    definition: 'A state where the person feels judged or threatened, and is protecting themselves rather than problem-solving.',
    category: 'emotional_state',
  },
  'reflective': {
    term: 'Reflective',
    definition: 'A state where the person is openly considering their role and the impact of their actions.',
    category: 'emotional_state',
  },
  'escalated': {
    term: 'Escalated',
    definition: 'A state where emotional intensity has risen to the point that productive conversation is at risk.',
    category: 'emotional_state',
  },
};

// Helper function to check if text contains a term
export function findTermsInText(text) {
  const lowerText = text.toLowerCase();
  const foundTerms = [];
  
  Object.keys(TERM_LIBRARY).forEach(key => {
    if (lowerText.includes(key.toLowerCase())) {
      foundTerms.push({
        key,
        ...TERM_LIBRARY[key],
      });
    }
  });
  
  return foundTerms;
}

// Get term by key
export function getTerm(key) {
  const lowerKey = key.toLowerCase();
  return TERM_LIBRARY[lowerKey] || null;
}

export default TERM_LIBRARY;
